import { LimitTypography } from '@aibees/elephant/components/limit-typography';
import { usePersonReadDataContext } from '@aibees/elephant/context';
import { useSearch } from '@aibees/shared/context';
import { classnames } from '@aibees/shared/utils';
import { Box, Skeleton, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ContactOverviewProps as Props } from './types';

export const ContactOverview = memo(({ className }: Props) => {
  const { api } = usePersonReadDataContext();
  const { search } = useSearch();

  if (!api?.data?.profile?.summary) return null;
  return (
    <Styled.Wrapper
      className={classnames('ContactOverview', className)}
      sx={SX.root}
    >
      <Typography variant="body3" fontWeight={700} color="grey.700">
        People Overview :
      </Typography>

      {api?.isLoading ? (
        <Skeleton animation="wave" variant="rounded" />
      ) : (
        <Box>
          <LimitTypography
            value={api?.data?.profile.summary}
            wordLimit={15}
            sx={SX.description}
            variant="body4"
            fontWeight={400}
            color="grey.700"
            search={search}
          />
        </Box>
      )}
    </Styled.Wrapper>
  );
});

ContactOverview.displayName = 'ContactOverview';
